export const AdvisorsList = [
      {
        id: 1,
        name: 'Aryan Lohia',
        fb: 'https://www.facebook.com/aryan.lohia.52687',
        instagram: ['frontend', 'ui/ux', 'design'],
        linkedin:'https://www.linkedin.com/in/aryan-lohia-a46b52213/',
        pfp: '/assets/images/Aryan.jpeg',
      },
      {
        id: 2,
        name: 'Himanshu Jangir',
        fb: 'https://www.facebook.com/share/1EcR1SabuD/?mibextid=wwXIfr',
        instagram: ['frontend', 'ui/ux', 'design'],
        linkedin:'https://www.linkedin.com/in/himanshu-jangir-868271290/',
        pfp: '/assets/images/Himanshu.jpg',
      },
      {
        id: 3,
        name: 'Dnyaneshwari Ghare',
        fb: 'https://www.facebook.com/share/1AsSWpgqdv/?mibextid=wwXIfr',
        instagram: ['frontend', 'ui/ux', 'design'],
        linkedin:'https://www.linkedin.com/in/dnyaneshwari-ghare-9a274928b/',
        pfp: '/assets/images/dnyaneshwari.jpg',
      },
      {
        id: 4,
        name: 'Tanush Agarwal',
        fb: 'https://www.facebook.com/people/Tanush-Agarwal/pfbid02eLEAKCznrfH2HXBbbBpPhM9XV6Arz3QNFaASr59NBndnWELTpAchXCYne3eXPQXRl/',
        instagram: ['frontend', 'ui/ux', 'design'],
        linkedin:'https://www.linkedin.com/in/tanush-agarwal-83893727a/',
        pfp: '/assets/images/Tanush.jpg',
      },
      {
        id: 5,
        name: 'Bhukya Shashi Kumar',
        fb: 'https://www.facebook.com/share/19FMr9AS2R/?mibextid=wwXIfr',
        instagram: ['frontend', 'ui/ux', 'design'],
        linkedin:'https://www.linkedin.com/in/shashi-kumar-bhukya-0882b8290/',
        pfp: '/assets/images/Shashi.jpg',
      },
      {
        id: 6,
        name: 'Katyayani Khola',
        fb: 'https://www.facebook.com/share/19J2tkhN3h/?mibextid=wwXIfr',
        instagram: ['frontend', 'ui/ux', 'design'],
        linkedin:'https://www.linkedin.com/in/katyayani-khola-00aa35293/',
        pfp: '/assets/images/katyayani.jpeg',
      },
      {
        id: 7,
        name: 'Bhavy Vaishnav',
        fb: 'https://www.facebook.com/share/1G88Nck6Ey/?mibextid=wwXIfr',
        instagram: ['frontend', 'ui/ux', 'design'],
        linkedin:'https://www.linkedin.com/in/bhavyvaishnav-kgpian/',
        pfp: '/assets/images/bhavy.jpg',
      },
      {
        id: 8,
        name: 'Gaurang Mehra',
        fb: 'https://www.facebook.com/people/Gaurang-Mehra/pfbid032ET79fxaZY6UDA1abdPX7XsWeCKMHSR713dCkHEhegt7HeGyvde6YekMkCJSuW1yl/',
        instagram: ['frontend', 'ui/ux', 'design'],
        linkedin:'https://www.linkedin.com/in/gaurang-mehra-177700196/',
        pfp: '/assets/images/gaurang.jpeg',
      },
      {
        id: 9,
        name: 'Shourya Godha',
        fb: 'https://www.facebook.com/share/1G51cu6Ki8/?mibextid=wwXIfr',
        instagram: ['frontend', 'ui/ux', 'design'],
        linkedin:'https://www.linkedin.com/in/shourya-godha-73050b28a/',
        pfp: '/assets/images/shourya1.jpeg',
      },
      {
        id: 10,
        name: 'Astitva Srivastava',
        fb: 'https://www.facebook.com/profile.php?id=100088417697358&mibextid=ZbWKwL',
        instagram: ['frontend', 'ui/ux', 'design'],
        linkedin:'https://www.linkedin.com/in/astitvaprofileview?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
        pfp: '/assets/images/astitva.jpg',
      },
      {
        id: 11,
        name: 'Bhawesh Kukreja',
        fb: 'https://www.facebook.com/bhawesh.kukreja.5?mibextid=ZbWKwL',
        instagram: ['frontend', 'ui/ux', 'design'],
        linkedin:'https://www.linkedin.com/in/bhawesh-kukreja-430a46257',
        pfp: '/assets/images/bhawesh.jpg',
      },
      {
        id: 12,
        name: 'Shashank Tiwari',
        fb: 'https://www.facebook.com/profile.php?id=100087904082305&mibextid=ZbWKwL',
        instagram: ['frontend', 'ui/ux', 'design'],
        linkedin:'https://www.linkedin.com/in/shashank-tiwari-9b16a724b',
        pfp: '/assets/images/shashank.jpg',
      },
      {
        id: 13,
        name: 'Shivam Bisen',
        fb: 'https://www.facebook.com/profile.php?id=100088844135102&mibextid=ZbWKwL',
        instagram: ['frontend', 'ui/ux', 'design'],
        linkedin:'https://www.linkedin.com/in/shivam-bisen-812927250',
        pfp: '/assets/images/shivam.jpg',
      },
];